import { render, staticRenderFns } from "./PSReportTable.vue?vue&type=template&id=7186f180&scoped=true&"
import script from "./PSReportTable.vue?vue&type=script&lang=js&"
export * from "./PSReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7186f180",
  null
  
)

export default component.exports